





// Measure all content elements and assign their height to a css variable in the style attribute of the html.
function measureAccordionContents( index, element ) {
  var contentHeight = $(element).find('.mobile-sub').outerHeight();
  console.log(contentHeight);
  element.style.setProperty('--expanded' , contentHeight + 'px');
}
$('.mobile-menu').each( measureAccordionContents );


function accordionEventHandler( clickEvent )
{
  clickEvent.preventDefault();
  var clickedItem = clickEvent.target;
  var text = $('.mobile-menu');
  text.toggleClass( 'is-visible').toggleClass( 'is-hidden' );
}
$("#wsnavtoggle-e").click( accordionEventHandler );



/*
 $(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  });
*/

$('#terms-and-coditions').scroll(function () {
    if ($(this).scrollTop() + $(this).innerHeight() +2 >= $(this)[0].scrollHeight) {
        
      document.getElementById("agree-and-checkout").innerHTML='I Agree. Check out!';
      
      $('#agree-and-checkout').removeAttr('disabled');
    }
});